import React, { useState, useEffect } from 'react'
import { Alert, Popconfirm, notification, Modal, Button, Checkbox } from 'antd'
import '../../../less/contract.less'
import {
  advanceOtpVerificationFxn,
  getUser2,
  sendAdvanceCommissionOtpFxn
} from '../actions/user'
import { connect, useDispatch } from 'react-redux'
import { displayDate } from '../../../components/_utils/appUtils'
import { listAllContractUniFxn } from '../../university/actions/university'

const AdvanceCommissionContract = () => {
  let user = localStorage.getItem('user')
    ? JSON.parse(localStorage.getItem('user'))
    : null
  let [userData, setUserData] = useState({})
  let [otpModalVisible, setOtpModalVisible] = useState(false)
  const [otp, setOtp] = useState(['', '', '', ''])
  let [termsAccepted, setTermsAccepted] = useState(false)
  let [universityArr, setUniversity] = useState([])
  console.log(universityArr, 'universityArr')
  let dispatch = useDispatch()

  let universityIds = [
    '60edc6529b7afb3e8a9e6fe7',
    '5fb4fd585296496bc032b090',
    '63806cde6afaf1468c8d4df3',
    '6030a53b1098b623411984a2',
    '61502d125afab225cad3ba94',
    '5fb4fd585296496bc032b08b',
    '615ff999b8eb76233f186b5f',
    '61431573d7c03d14accce184',
    '60fe906ac36c250b33dd8e60',
    '5fb4fd585296496bc032b094',
    '5fb4fd585296496bc032b096',
    '603638161098b623411991c3'
  ]

  useEffect(() => {
    events.singleUser()
    events.loadUniversity()
  }, [])

  const events = {
    loadUniversity: async () => {
      let resp = await dispatch(listAllContractUniFxn({ universityIds }))
      setUniversity(resp)
    },
    singleUser: async () => {
      let resp = await dispatch(getUser2({ userId: user._id }))
      setUserData(resp)
    },
    downloadContract: () => {
      if (userData && userData.advanceCommissionContract && userData.advanceCommissionContract.url) {
        window.open(userData.advanceCommissionContract.url, 'download')
      }
    }
  }

  const eventFxn = {
    handleSignClick: async () => {
      if (termsAccepted == false) {
        notification.info({ message: 'Please accept the terms and conditions to continue' })
        return
      }

      if (userData.contractSigned) {
        notification.info({ message: 'Contract already signed' })
        return
      }
      const response = await dispatch(sendAdvanceCommissionOtpFxn({ userId: user._id }))
      if (response.success) {
        setOtpModalVisible(true)
      }
    },
    handleOtpVerification: async () => {
      const enteredOtp = otp.join('')
      const { success } = await dispatch(advanceOtpVerificationFxn({ otp: enteredOtp }))
      if (success) {
        setOtp(['', '', '', ''])
        events.singleUser()

        Modal.success({
          width: '40%',
          title: 'Great! Congratulations on signing the Advance Commission Contract.',
          okText: 'Close',
          centered: true
        })

        setOtpModalVisible(false)
      } else {
        setOtp(['', '', '', ''])
      }
    }
  }

  const handleChange = (element, index) => {
    if (isNaN(element.value)) return

    let newOtp = [...otp]
    newOtp[index] = element.value
    setOtp(newOtp)

    // Focus next input
    if (element.nextSibling) {
      element.nextSibling.focus()
    }
  }

  return (
    <div className='Commission-contract-wrapper font-poppins'>
      <div className='text-center mt-4 '>
        <div>
          <h2 className={'fw800 fs36'} style={{ color: 'black' }}>£500 Pounds on eligible <span
            style={{ color: '#E21F1D' }}>UK CAS Letter</span>
          </h2>
        </div>
        <br />
        <h4 className={'label label-default contract-header2 mt-4'}>You will receive
          a £500 Commission Advance
          upon the issuance
          of the CAS.</h4>
      </div>
      <div className='contract-content'>
        <h3 className='text-center blueHeading contract-blue-color'>In below Mentioned Universities</h3>
        <div className='universities-list text-center'>
          <div className='row'>
            {universityArr.map((uni, index) => (
              <div key={index} className='d-flex flex-wrap col-6 col-md-3 mb-2'>
                <div className='image-block'>
                  <img src={uni.logo.url} />
                </div>
              </div>
            ))}
          </div>
        </div>


        <div className=' mt-4 fs16 lh100'>
          <p><b>Terms and Conditions:</b></p>
          <ol>
            <li>1. You will receive £500 on receiving CAS letter.</li>
            <li>2. In any case we will not receive commission due to student withdrawal, visa rejection or any other
              issue, we will deduct advance commission from future student commission.
            </li>
          </ol>
        </div>


        <div className=' mt-5 fs14 lh100 contractLh'>
          <p><b>Contact:</b></p>
          <p>Any questions regarding this Agreement, or any questions, complaints, claims or other legal concerns
            relating to UnizPortal or its business, should be directed to: <b>Email: puneet@unizportal.com</b> or <b>Phone:
              +91 95608 47414</b></p>
          <p>If your complaint or concern is not resolved by contacting puneet@unizportal.com, you may escalate it to
            the
            Complaint Section handled under the observation of our UK operations: <b>Mr. Puneet Atreja</b>.
          </p>
        </div>


        {!userData.contractSigned &&
        <div className='Commission-contract-terms '>
          <br />
          <Alert
            message={
              <Checkbox
                checked={termsAccepted}
                onChange={e => setTermsAccepted(e.target.checked)}>
                I accept that in the event of visa rejection or if the commission is not received,
                the advance amount will be deducted from my future student commission earnings.
              </Checkbox>
            }
            type='info'
          />
        </div>
        }

        <div className='text-center mt-4'>
          {userData.contractSigned ? (
            <>
              <h5 className='text-success'>Contract Signed</h5>
              <div className='sign-info'>
                <div>
                  <p>Signed on <strong>{displayDate(userData.contractDate)}</strong></p>
                  <p>Signed by <strong>{userData.name}</strong></p>
                </div>
                <div>
                  <p>Email <strong>{userData && userData.userId && userData.userId.email ? userData.userId.email : '--'}</strong>
                  </p>
                  <p>Contact
                    No. <strong>{userData && userData.userId && userData.userId.mobile ? userData.userId.mobile : '--'}</strong>
                  </p>
                </div>
              </div>
              <button className='download-btn' onClick={events.downloadContract}>Download Advance Contract</button>

            </>
          ) : (
            <div className='d-flex justify-content-end'>
              <Button type='primary' size='large' style={{ backgroundColor: '#0056b3', borderColor: '#0056b3' }}
                      onClick={eventFxn.handleSignClick}>
                Sign Now!
              </Button>
            </div>
          )}
        </div>
      </div>

      {otpModalVisible && (
        <Modal
          width={'30%'}
          title='Enter OTP'
          visible={otpModalVisible}
          onCancel={() => setOtpModalVisible(false)}
          footer={false}
        >
          <div className='otp-container'>
            <h2 className={'blueHeading contract-blue-color'}>OTP Verification</h2>
            <p>Enter the verification code we sent
              to <strong>{user.email} {user.mobile ? `& ${user.mobile}` : ''}</strong></p>

            <div className=' d-flex flex-column'>
              <p>Type your OTP here</p>
              <div className={'otp-inputs'}>
                {otp.map((data, index) => (
                  <input
                    key={index}
                    type='text'
                    maxLength='1'
                    value={data}
                    onChange={e => handleChange(e.target, index)}
                    onFocus={e => e.target.select()}
                  />
                ))}
              </div>
            </div>


            <p className='resend-text'>
              Didn’t receive the OTP?
              <span className='resend-link'
                    onClick={eventFxn.handleSignClick}
              > Resend OTP</span>
            </p>
            <button className='verify-btn' onClick={eventFxn.handleOtpVerification}>Verify</button>
          </div>
        </Modal>
      )}
    </div>
  )
}

const mapStateToProps = ({ global }) => ({
  currentUserRights: global.currentUserRights
})

export default connect(mapStateToProps, null)(AdvanceCommissionContract)
